export enum SvgIconsNames {
    WinterStorage = 'winter-storage',
}
